import React from 'react';
import './App.css';
import './css/code.css';

import Prodown from './Prodown';
import Privacy from './Company/Privacy';
import Contact from './Company/Contact';
import About from './Company/About';
import Home from './Home';
import Error from './error'
import Navbar from './Navbar';
import Extra from './Extra';
import Disclaimer from './Company/Disclaimer';
import Terms_and_conditions from './Company/Terms_and_conditions';

import Allpro from './Allpro';



//Java Tutorial

import Jhistory from './allJava/Jhistory';
import Jfeatures from './allJava/Jfeatures';
import Jcomments from './allJava/Jcomment';
import Jvariable from './allJava/Jvariable';
import Jtypevar from './allJava/Jtypevar';
import Jidentifier from './allJava/Jidentifier';
import Jstring from './allJava/Jstring';
import Jliteral from './allJava/Jliteral';
import Jdatatype from './allJava/Jdatatype';
import Jopeartor from './allJava/Joperator';
import Jkeyword from './allJava/Jkeyword';
import Jfirstpro from './allJava/Jfirstpro';

import Jcontrol from './allJava/Jcontrol';
import Jif from './allJava/Jif';
import Jifelse from './allJava/Jifelse';
import Jifelseif from './allJava/Jifelseif';
import Jconditional from './allJava/Jconditional';
import Jswitch from './allJava/Jswitch';
import Jloop from './allJava/Jloop';
import Jwhile from './allJava/Jwhile';
import Jdowhile from './allJava/Jdowhile';
import Jforloop from './allJava/Jforloop';
import Jbreak from './allJava/Jbreak';
import Jcontinue from './allJava/Jcontinue';
import Jarray from './allJava/Jarray';

import Joops from './allJava/Joops';
import Jclassob from './allJava/Jclassob';
import Jmethod from './allJava/Jmethod';
import Juserfunction from './allJava/Juserfunction';
import Jobjectinit from './allJava/Jobjectinit';
import Jconstructor from './allJava/Jconstruct';
import Jinherit from './allJava/Jinherit';
import Jsigleinherit from './allJava/Jsingleinherit';
import Jmultilevel from './allJava/Jmultilevel';
import Jhierarchical from './allJava/Jhierachical';
import Jassociation from './allJava/Jassociation';
import Joverloading from './allJava/Joverload';
import Joverriding from './allJava/Joverride';
import Jpassarg from './allJava/Jpassarg';
import Jenum from './allJava/Jenum';
//java tutorial

//Csharp Tutorial


import Cshistory from './allcsharp/Cshistory';
import Csintro from './allcsharp/Csintro';
import Cscomments from './allcsharp/Cscomments';
import Csfirstpro from './allcsharp/Csfirstpro';
import Cskeyword from './allcsharp/Cskeyword';
import Csoperator from './allcsharp/Csoperator';
import Csdatatypes from './allcsharp/Csdatatypes';
import Csvariable from './allcsharp/Csvariable';
import Csidentifier from './allcsharp/Csidentifier';
import Csinput from './allcsharp/Csinput';
import Csliteral from './allcsharp/Csliteral';

import Csnamespace from './allcsharp/Csnamespace';
import Csstring from './allcsharp/Csstring';
import Cscontrolstruct from './allcsharp/Cscontrolstruct';
import Csif from './allcsharp/Csif';
import Csifelse from './allcsharp/Csifelse';
import Csifelseif from './allcsharp/Csifelseif';
import Csconditionoper from './allcsharp/Csconditionoper';
import Csswitch from './allcsharp/Csswitch';
import Csloopingstat from './allcsharp/Csloopingstatm';
import Cswhile from './allcsharp/Cswhile';
import Csdowhile from './allcsharp/Csdowhile';
import Csforloop from './allcsharp/Csforloop';
import Csbreak from './allcsharp/Csbreak';
import Cscontinue from './allcsharp/Cscontinue';
import Csgoto from './allcsharp/Csgoto';
import Csarray from './allcsharp/Csarray';
import Csoops from './allcsharp/Csoops';
import Csclassobject from './allcsharp/Csclassobject';
import Csmethod from './allcsharp/Csmethod';
import Csuserfunct from './allcsharp/Csuserfunct';
import Cspassarg from './allcsharp/Cspassarg';
import Csobjectinit from './allcsharp/Csobjectinit';
import Csconstructor from './allcsharp/Csconstruct';
import Csinherit from './allcsharp/Csinherit';
import Cssingleinherit from './allcsharp/Cssingleinherit';
import Csmultilevelinherit from './allcsharp/Csmultilevelinherit';
import Csassociation from './allcsharp/Csassociation';
import Csoverload from './allcsharp/Csoverload';
import Csoverride from './allcsharp/Csoverride';
//Csharp tutorial

//Python Tutorial

import Phome from './allpython/Phome';
import Pvariable from './allpython/Pvariable';
import Pidentifier from './allpython/Pidentifier';
import Pkeyword from './allpython/Pkeyword';

import Pinput from './allpython/Pinput';
import Pcomment from './allpython/Pcomment';

import Poperator from './allpython/Poperator';

import Pstring from './allpython/Pstring';
import Pcontrolstruct from './allpython/Pcontrolstruct';
import Pif from './allpython/Pif';

import Pifelse from './allpython/Pifelse';
import Pifelseif from './allpython/Pifelseif';

import Ploop from './allpython/Ploop';
import Pwhile from './allpython/Pwhile';

import Pforloop from './allpython/Pforloop';

import Pbreak from './allpython/Pbreak';
import Pcontinue from './allpython/Pcontinue';
import Plambda from './allpython/Plambda';
import Plist from './allpython/Plist';
import Plistmeth from './allpython/Plistmeth';
import Ptypevar from './allpython/Ptypevar';
import Poops from './allpython/Poops';
import Pobjclass from './allpython/Pobjclass';
import Pdictionari from './allpython/Pdictionari';
import Ptuple from './allpython/Ptuple';
import Pinherit from './allpython/Pinherit';
import Pfunctionoverload from './allpython/Pfunctionoverload';
import Pfunctionoverride from './allpython/Pfunctoverride';
import Pconstruct from './allpython/Pconstruct';

import Psearch from './allpython/Psearch';
import Pfunction from './allpython/Pfunction';
import Pfunctarg from './allpython/Pfunctarg';
import Pexcepthandle from './allpython/Pexcepthandle';
//Python Tutorial

//c tutorial


import Celement from './allC/Celement';


import Cscopeofvar from './allC/Cscopevar';
import Ckeyword from './allC/Ckeyword';
import Cdatatypes from './allC/Cdatatypes';

import Cvariable from './allC/Cvariable';
import Cidentifier from './allC/Cidentifier';
import Cshortkeys from './allC/Cshortkeys';
import Cfirstpro from './allC/Cbasics';
import Cinput from './allC/Cinput';
import Cliteral from './allC/Cliterals';
import Coperator from './allC/Coperator';
import Ccontrolstruct from './allC/Ccontrolstatm';
import Cif from './allC/Cif';
import Cifelse from './allC/Cifelse';
import Cifelseif from './allC/Cifelseif';
import Cconditionoper from './allC/Cconditionaloper';
import Cswitch from './allC/Cswitch';
import Cgoto from './allC/Cgoto';
import Clooping from './allC/Clooping';
import Cwhile from './allC/Cwhile';
import Cdowhile from './allC/Cdowhile';
import Cforloop from './allC/Cforloop';
import Cbreak from './allC/Cbreak';
import Ccontinue from './allC/Ccontinue';
import Carray from './allC/Carray';
import Csearching from './allC/Csearching';
import Cfunction from './allC/Cfunction';
import Cuserdefined from './allC/Cuserfunct';
import Cpassarg from './allC/Cpassarg';
import Creturnvalue from './allC/Creturnvalue';
import chistory from './allC/Chistory';
//c tutorial


//cpp tutorial

import cpphistory from './allcpp/Cpphistory';
import Cppelement from './allcpp/Cppelement';


import Cppscopeofvar from './allcpp/Cppscopevar';
import Cppkeyword from './allcpp/Cppkeyword';
import Cppdatatypes from './allcpp/Cppdatatypes';

import Cppvariable from './allcpp/Cppvariable';
import Cppidentifier from './allcpp/Cppidentifier';

import Cppbasic from './allcpp/Cppbasics';
import Cppinput from './allcpp/Cppinput';
import Cppliteral from './allcpp/Cppliterals';
import Cppoperator from './allcpp/Cppoperator';
import Cppcontrolstruct from './allcpp/Cppcontrolstatm';
import Cppif from './allcpp/Cppif';
import Cppifelse from './allcpp/Cppifelse';
import Cppifelseif from './allcpp/Cppifelseif';
import Cppconditionoper from './allcpp/Cppconditionaloper';
import Cppswitch from './allcpp/Cppswitch';
import Cppgoto from './allcpp/Cppgoto';
import Cpplooping from './allcpp/Cpplooping';
import Cppwhile from './allcpp/Cppwhile';
import Cppdowhile from './allcpp/Cppdowhile';
import Cppforloop from './allcpp/Cppforloop';
import Cppbreak from './allcpp/Cppbreak';
import Cppcontinue from './allcpp/Cppcontinue';
import Cpparray from './allcpp/Cpparray';
import Cppsearching from './allcpp/Cppsearching';
import Cppfunction from './allcpp/Cppfunction';
import Cppuserdefined from './allcpp/Cppuserfunct';
import Cpppassarg from './allcpp/Cpppassarg';
import Cppreturnvalue from './allcpp/Cppreturnvalue';

//php

import phpsetup from './allphp/Phpsetup';
import phpintro from './allphp/Phpintro';
import phpcomment from './allphp/Phpcomment';
import phpdowhile from './allphp/Phpdowhile';

import phpfirstpro from './allphp/Phpfirstpro';
import phpforloop from './allphp/Phpforloop';
import phpfunction from './allphp/Phpfunction';
import phpgoto from './allphp/Phpgoto';
import phpcontinue from './allphp/Phpcontinue';
import phpbreak from './allphp/Phpbreak';

import phpidentifier from './allphp/Phpidentifier';
import phpif from './allphp/Phpif';
import phpifelse from './allphp/Phpifelse';
import phpifelseif from './allphp/Phpifelseif';

import phpoperator from './allphp/Phpoperator';

import phpswitch from './allphp/Phpswitch';
import phpuserfunct from './allphp/Phpuserfunct';

import phpvariable from './allphp/Phpvariable';
import phpwhile from './allphp/Phpwhile';

import phpkeyword from './allphp/Phpkeyword';
import phploopstat from './allphp/Phploopstat';
import phpcontrstru from './allphp/Phpcontrstru';
import phphistory from './allphp/Phphistory';




//php

//js
import Jshistory from './alljs/Jshistory';

import Jsbreak from './alljs/Jsbreak';
import Jscomment from './alljs/Jscomment';
import Jsccontinue from './alljs/Jscontinue';
import Jsdowhile from './alljs/Jsdowhile';
import Jscontrolstru from './alljs/Jscontrolstru';
import Jsfirstpro from './alljs/Jsfirstpro';
import Jsforloop from './alljs/Jsforloop';
import Jsfunction from './alljs/Jsfunction';



import Jsidentifier from './alljs/Jsidentifier';
import Jsif from './alljs/Jsif';
import Jsifelse from './alljs/Jsifelse';
import Jsifelseif from './alljs/Jsifelseif';



import Jskeyword from './alljs/Jskeyword';

import Jsloopstat from './alljs/Jsloopstat';
import Jsoperator from './alljs/Jsoperator';

import Jsswitch from './alljs/Jsswitch';
import Jsvariable from './alljs/Jsvariable';
import Jswhile from './alljs/Jswhile';
import Jsuserfunct from './alljs/Jsuserfunct';
import Jsdom from './alljs/Jsdom';



//Javascript







//diff cjcs
import Jcscbasic from './Djcs/Jcsbasic';
import Jcsif from './Djcs/Jcsif';
import Jcsifelse from './Djcs/Jcsifelse';
import Jcsswitch from './Djcs/Jcsswitch';
import Jcswhile from './Djcs/Jcswhile';
import Jcsfunction from './Djcs/Jcsfunction';

//diff cjcs

// diff jp

import Djpbasic from './Difference Bw Java and Python/Jpbasic';
import Djpif from './Difference Bw Java and Python/Jpif';
import Djpifelse from './Difference Bw Java and Python/Jpifelse';

import Djpwhile from './Difference Bw Java and Python/Jpwhile';
import Djpfunction from './Difference Bw Java and Python/Jpfunction';
//diffjp







import { BrowserRouter, Route, Switch } from 'react-router-dom';



function App() {
  return (<BrowserRouter>
    <div >

      <Navbar />

      <Switch>
        <Route path="/" exact component={Home} />

        <Route path="/privacy-policy" component={Privacy} />
        <Route path="/about-us" component={About} />
        <Route path="/contact-us" component={Contact} />
        <Route path="/disclaimer" component={Disclaimer} />
        <Route path="/terms-and-conditions" component={Terms_and_conditions} />
        <Route path="/programming-language-to-learn" component={Allpro} />
        <Route path="/ext" component={Extra} />


        {/* 
 java tutorial 
*/}

        <Route path="/java-history" component={Jhistory} />
        <Route path="/java-features" component={Jfeatures} />
        <Route path="/java-comments" component={Jcomments} />
        <Route path="/java-variables" component={Jvariable} />
        <Route path="/java-types-of-variables" component={Jtypevar} />
        <Route path="/java-identifier" component={Jidentifier} />

        <Route path="/java-string" component={Jstring} />
        <Route path="/java-literals" component={Jliteral} />
        <Route path="/java-data-types" component={Jdatatype} />
        <Route path="/java-operators" component={Jopeartor} />
        <Route path="/java-keywords" component={Jkeyword} />

        <Route path="/java-first-program" component={Jfirstpro} />
        <Route path="/java-control-structure" component={Jcontrol} />
        <Route path="/java-if" component={Jif} />
        <Route path="/java-if-else" component={Jifelse} />
        <Route path="/java-if-else-if" component={Jifelseif} />

        <Route path="/java-conditional-operator" component={Jconditional} />
        <Route path="/java-switch" component={Jswitch} />
        <Route path="/java-looping" component={Jloop} />
        <Route path="/java-while" component={Jwhile} />
        <Route path="/java-do-while" component={Jdowhile} />

        <Route path="/java-for-loop" component={Jforloop} />
        <Route path="/java-break" component={Jbreak} />
        <Route path="/java-continue" component={Jcontinue} />
        <Route path="/java-array" component={Jarray} />
        <Route path="/java-oops" component={Joops} />

        <Route path="/java-class-and-object" component={Jclassob} />
        <Route path="/java-method" component={Jmethod} />
        <Route path="/java-user-defined-function" component={Juserfunction} />
        <Route path="/java-object-initialize" component={Jobjectinit} />
        <Route path="/java-constructor" component={Jconstructor} />

        <Route path="/java-inheritance" component={Jinherit} />
        <Route path="/java-single-inheritance" component={Jsigleinherit} />
        <Route path="/java-multilevel-inheritance" component={Jmultilevel} />
        <Route path="/java-hierarchical-inheritance" component={Jhierarchical} />
        <Route path="/java-association" component={Jassociation} />
        <Route path="/java-overloading" component={Joverloading} />
        <Route path="/java-overriding" component={Joverriding} />
        <Route path="/java-passing-argument" component={Jpassarg} />
        <Route path="/java-enum" component={Jenum} />


        {/* 
 java tutorial 
*/}


        {/* 
 Csharp tutorial 
*/}

        <Route path="/csharp-history" component={Cshistory} />
        <Route path="/csharp-introduction" component={Csintro} />
        <Route path="/csharp-comments" component={Cscomments} />
        <Route path="/csharp-first-program" component={Csfirstpro} />
        <Route path="/csharp-keyword" component={Cskeyword} />
        <Route path="/csharp-operator" component={Csoperator} />


        <Route path="/csharp-datatypes" component={Csdatatypes} />
        <Route path="/csharp-variable" component={Csvariable} />
        <Route path="/csharp-identifier" component={Csidentifier} />
        <Route path="/csharp-input" component={Csinput} />
        <Route path="/csharp-literal" component={Csliteral} />
        <Route path="/csharp-namespace" component={Csnamespace} />

        <Route path="/csharp-string" component={Csstring} />
        <Route path="/csharp-control-structure" component={Cscontrolstruct} />
        <Route path="/csharp-if" component={Csif} />


        <Route path="/csharp-if-else" component={Csifelse} />
        <Route path="/csharp-if-else-if" component={Csifelseif} />
        <Route path="/csharp-conditional-operator" component={Csconditionoper} />

        <Route path="/csharp-switch" component={Csswitch} />
        <Route path="/csharp-looping-statement" component={Csloopingstat} />
        <Route path="/csharp-while" component={Cswhile} />


        <Route path="/csharp-do-while" component={Csdowhile} />
        <Route path="/csharp-for-loop" component={Csforloop} />
        <Route path="/csharp-break" component={Csbreak} />

        <Route path="/csharp-continue" component={Cscontinue} />
        <Route path="/csharp-goto" component={Csgoto} />
        <Route path="/csharp-array" component={Csarray} />




        <Route path="/csharp-oops" component={Csoops} />
        <Route path="/csharp-class-object" component={Csclassobject} />
        <Route path="/csharp-method" component={Csmethod} />

        <Route path="/csharp-user-define-function" component={Csuserfunct} />
        <Route path="/csharp-passing-argument" component={Cspassarg} />
        <Route path="/csharp-object-initializers" component={Csobjectinit} />


        <Route path="/csharp-constructor" component={Csconstructor} />
        <Route path="/csharp-inheritance" component={Csinherit} />
        <Route path="/csharp-single-inheritance" component={Cssingleinherit} />

        <Route path="/csharp-multilevel-inheritance" component={Csmultilevelinherit} />
        <Route path="/csharp-association" component={Csassociation} />
        <Route path="/csharp-overloading" component={Csoverload} />
        <Route path="/csharp-overriding" component={Csoverride} />



        {/* 
 Csharp tutorial
*/}

        {/* 
Python tutorial 
*/}

        <Route path="/python-history" component={Phome} />
        <Route path="/python-variables" component={Pvariable} />
        <Route path="/python-identifiers" component={Pidentifier} />

        <Route path="/python-keywords" component={Pkeyword} />

        <Route path="/python-input" component={Pinput} />
        <Route path="/python-comments" component={Pcomment} />
        <Route path="/python-operators" component={Poperator} />
        <Route path="/python-string" component={Pstring} />
        <Route path="/python-control-structure" component={Pcontrolstruct} />

        <Route path="/python-if" component={Pif} />
        <Route path="/python-if-else" component={Pifelse} />
        <Route path="/python-if-else-if" component={Pifelseif} />

        <Route path="/python-looping" component={Ploop} />
        <Route path="/python-while" component={Pwhile} />
        <Route path="/python-for-loop" component={Pforloop} />

        <Route path="/python-break" component={Pbreak} />
        <Route path="/python-continue" component={Pcontinue} />
        <Route path="/python-lambda" component={Plambda} />
        <Route path="/python-list" component={Plist} />
        <Route path="/python-list-method" component={Plistmeth} />

        <Route path="/python-types-of-variable" component={Ptypevar} />
        <Route path="/python-oops" component={Poops} />
        <Route path="/python-object-and-class" component={Pobjclass} />
        <Route path="/python-dictionary" component={Pdictionari} />
        <Route path="/python-tuple" component={Ptuple} />

        <Route path="/python-inheritance" component={Pinherit} />
        <Route path="/python-function-overloading" component={Pfunctionoverload} />
        <Route path="/python-function-overriding" component={Pfunctionoverride} />
        <Route path="/python-constructor" component={Pconstruct} />
        <Route path="/python-searching" component={Psearch} />
        <Route path="/python-function" component={Pfunction} />
        <Route path="/python-function-argument" component={Pfunctarg} />
        <Route path="/python-exception-handling" component={Pexcepthandle} />

        {/* 
Python tutorial 
*/}



        {/* 
C tutorial 
*/}


        <Route path="/c-history" component={chistory} />
        <Route path="/c-element" component={Celement} />

        <Route path="/c-variable" component={Cvariable} />
        <Route path="/c-scope-of-variable" component={Cscopeofvar} />
        <Route path="/c-keyword" component={Ckeyword} />
        <Route path="/c-datatypes" component={Cdatatypes} />

        <Route path="/c-identifier" component={Cidentifier} />

        <Route path="/c-short-cut-keys" component={Cshortkeys} />

        <Route path="/c-first-program" component={Cfirstpro} />
        <Route path="/c-input" component={Cinput} />
        <Route path="/c-literal" component={Cliteral} />
        <Route path="/c-operator" component={Coperator} />

        <Route path="/c-control-structure" component={Ccontrolstruct} />
        <Route path="/c-if" component={Cif} />
        <Route path="/c-if-else" component={Cifelse} />
        <Route path="/c-if-else-if" component={Cifelseif} />

        <Route path="/c-conditional-operator" component={Cconditionoper} />
        <Route path="/c-switch" component={Cswitch} />
        <Route path="/c-goto" component={Cgoto} />
        <Route path="/c-looping" component={Clooping} />

        <Route path="/c-while" component={Cwhile} />
        <Route path="/c-do-while" component={Cdowhile} />
        <Route path="/c-for-loop" component={Cforloop} />
        <Route path="/c-break" component={Cbreak} />

        <Route path="/c-continue" component={Ccontinue} />
        <Route path="/c-array" component={Carray} />
        <Route path="/c-searching" component={Csearching} />
        <Route path="/c-function" component={Cfunction} />

        <Route path="/c-user-defined-function" component={Cuserdefined} />
        <Route path="/c-passing-argument" component={Cpassarg} />
        <Route path="/c-return-value" component={Creturnvalue} />


        {/* 
C tutorial 
*/}


        {/* 
Cpp tutorial 
*/}
        <Route path="/cpp-history" component={cpphistory} />

        <Route path="/cpp-element" component={Cppelement} />
        <Route path="/cpp-variable" component={Cppvariable} />
        <Route path="/cpp-scope-of-variable" component={Cppscopeofvar} />
        <Route path="/cpp-keyword" component={Cppkeyword} />

        <Route path="/cpp-data-types" component={Cppdatatypes} />

        <Route path="/cpp-identifier" component={Cppidentifier} />


        <Route path="/cpp-first-program" component={Cppbasic} />
        <Route path="/cpp-input" component={Cppinput} />



        <Route path="/cpp-literal" component={Cppliteral} />
        <Route path="/cpp-operator" component={Cppoperator} />
        <Route path="/cpp-control-structure" component={Cppcontrolstruct} />

        <Route path="/cpp-if" component={Cppif} />
        <Route path="/cpp-if-else" component={Cppifelse} />
        <Route path="/cpp-if-else-if" component={Cppifelseif} />

        <Route path="/cpp-conditional-operator" component={Cppconditionoper} />
        <Route path="/cpp-switch" component={Cppswitch} />
        <Route path="/cpp-goto" component={Cppgoto} />


        <Route path="/cpp-looping" component={Cpplooping} />
        <Route path="/cpp-while" component={Cppwhile} />
        <Route path="/cpp-do-while" component={Cppdowhile} />

        <Route path="/cpp-for-loop" component={Cppforloop} />
        <Route path="/cpp-break" component={Cppbreak} />
        <Route path="/cpp-continue" component={Cppcontinue} />

        <Route path="/cpp-array" component={Cpparray} />
        <Route path="/cpp-searching" component={Cppsearching} />
        <Route path="/cpp-function" component={Cppfunction} />

        <Route path="/cpp-user-defined-function" component={Cppuserdefined} />
        <Route path="/cpp-passing-argument" component={Cpppassarg} />
        <Route path="/cpp-return-value" component={Cppreturnvalue} />
        {/* 
Cpp tutorial 
*/}


        {/* 
php tutorial 
*/}

        <Route path="/php-history" component={phphistory} />
        <Route path="/php-setup" component={phpsetup} />
        <Route path="/php-introduction" component={phpintro} />
        <Route path="/php-variables" component={phpvariable} />

        <Route path="/php-keyword" component={phpkeyword} />
        <Route path="/php-identifier" component={phpidentifier} />

        <Route path="/php-comments" component={phpcomment} />


        <Route path="/php-first-program" component={phpfirstpro} />
        <Route path="/php-operator" component={phpoperator} />

        <Route path="/php-control-structure" component={phpcontrstru} />

        <Route path="/php-if" component={phpif} />

        <Route path="/php-if-else" component={phpifelse} />
        <Route path="/php-if-else-if" component={phpifelseif} />
        <Route path="/php-switch" component={phpswitch} />

        <Route path="/php-goto" component={phpgoto} />
        <Route path="/php-looping-statement" component={phploopstat} />

        <Route path="/php-while" component={phpwhile} />
        <Route path="/php-do-while" component={phpdowhile} />


        <Route path="/php-for-loop" component={phpforloop} />

        <Route path="/php-break" component={phpbreak} />
        <Route path="/php-continue" component={phpcontinue} />
        <Route path="/php-function" component={phpfunction} />

        <Route path="/php-user-define-function" component={phpuserfunct} />


        {/* 
php tutorial 
*/}



        {/* 
javascript tutorial 
*/}





        <Route path="/javascript-history" component={Jshistory} />

        <Route path="/javascript-comment" component={Jscomment} />
        <Route path="/javascript-variables" component={Jsvariable} />
        <Route path="/javascript-keyword" component={Jskeyword} />
        <Route path="/javascript-identifier" component={Jsidentifier} />

        <Route path="/javascript-operator" component={Jsoperator} />
        <Route path="/javascript-first-program" component={Jsfirstpro} />


        <Route path="/javascript-control-structure" component={Jscontrolstru} />
        <Route path="/javascript-if" component={Jsif} />
        <Route path="/javascript-if-else" component={Jsifelse} />



        <Route path="/javascript-if-else-if" component={Jsifelseif} />

        <Route path="/javascript-switch" component={Jsswitch} />



        <Route path="/javascript-looping-statement" component={Jsloopstat} />
        <Route path="/javascript-while" component={Jswhile} />
        <Route path="/javascript-do-while" component={Jsdowhile} />


        <Route path="/javascript-for-loop" component={Jsforloop} />
        <Route path="/javascript-break" component={Jsbreak} />
        <Route path="/javascript-continue" component={Jsccontinue} />
        <Route path="/javascript-function" component={Jsfunction} />

        <Route path="/javascript-user-define-function" component={Jsuserfunct} />

        <Route path="/javascript-dom-method" component={Jsdom} />

        {/* 
Javascript tutorial 
*/}












        {/* 
Diffjcs tutorial 
*/}

        <Route path="/java-vs-csharp-basic" component={Jcscbasic} />
        <Route path="/java-vs-csharp-if" component={Jcsif} />
        <Route path="/java-vs-csharp-if-else" component={Jcsifelse} />
        <Route path="/java-vs-csharp-switch" component={Jcsswitch} />
        <Route path="/java-vs-csharp-while" component={Jcswhile} />
        <Route path="/java-vs-csharp-function" component={Jcsfunction} />

        {/* 
Diffjcs tutorial 
*/}


        {/* 
DiffjPythtutorial 
*/}

        <Route path="/java-vs-python-basic" component={Djpbasic} />
        <Route path="/java-vs-python-if" component={Djpif} />
        <Route path="/java-vs-python-if-else" component={Djpifelse} />
        <Route path="/java-vs-python-while" component={Djpwhile} />
        <Route path="/java-vs-python-function" component={Djpfunction} />




        {/* 
DiffjPythtutorial 
*/}

        <Route component={Error} />
      </Switch>

      <Prodown />




    </div>
  </BrowserRouter>
  );
}


export default App;
